import React from "react";
import assetimages from "./assetimages";
import PerfectScrollbar from "perfect-scrollbar";
import { Link } from "react-router-dom";
import ApiRequest from "./restservice";
import { errorToast } from "./showtoast";

export default class SideMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSubmenu: "",
      prdprice: "0",
    };
  }
  componentDidMount() {
    let container = document.getElementById("app-sidebar");
    const ps = new PerfectScrollbar(container);
    console.log(ps);
    this.getProfileDetails();
  }
  async getProfileDetails() {
    let res = await ApiRequest("MyProfile.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState({
      prdprice: res.prdprice,
    });
  }
  OpenMenu() {
    let elementdiv = document.getElementById("app");
    if (elementdiv.classList.contains("sidenav-toggled")) {
      elementdiv.classList.remove("sidenav-toggled");
    }
  }
  render() {
    return (
      <aside
        className="app-sidebar ps ps--active-y"
        onMouseEnter={() => {
          if (
            document.getElementById("app").classList.contains("sidenav-toggled")
          ) {
            document.getElementById("app").classList.add("sidenav-toggled1");
            document.getElementById("app").classList.remove("sidenav-toggled");
          }
        }}
        onMouseLeave={() => {
          if (
            document.getElementById("app").classList.contains("sidenav-toggled1")
          ) {
            document.getElementById("app").classList.remove("sidenav-toggled1");
            document.getElementById("app").classList.add("sidenav-toggled");
          }
        }}
        id="app-sidebar"
        style={{ background: "#fff" }}
      >
        <div className="app-sidebar__logo mb-2">
          <label className="header-brand mb-0">
            <img
              src={assetimages.logo}
              className="header-brand-img desktop-lgo"
              alt=""
            />
            <img
              src={assetimages.favicon}
              className="header-brand-img mobile-logo"
              alt=""
            />
          </label>
        </div>

        <ul className="side-menu app-sidebar3 __user" id="accordion">
          <li className="side-item side-item-category mt-5">
            <label className="mt-4">MAIN</label>
          </li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              className={`side-menu__item ${
                window.location.href.includes("home") ||
                window.location.href.includes("dashboard")
                  ? "active"
                  : ""
              }`}
              to="/home"
            > 
              <i className="icon-home"></i>
              <span className="side-menu__label ml-4">Dashboard</span>
            </Link>
          </li>
          {/* <li className="slide" onClick={() => {
            let elementdiv = document.getElementById("app");
            if (window.innerWidth < 700 && elementdiv.classList.contains("sidenav-toggled")) {
              elementdiv.classList.remove("sidenav-toggled");
            }
          }}>
            <Link className={`side-menu__item ${window.location.href.includes("upgrade") ? "active" : ""}`} to="/upgrade">
              <i className="icon-grid"></i>
              <span className="side-menu__label ml-4">Upgrade</span>
            </Link>
          </li> */}
          <li className="side-item side-item-category mt-4">PROFILE</li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/profile"
              className={`side-menu__item ${
                window.location.href.includes("/profile") ? "active" : ""
              }`}
            >
              <i className="icon-user"></i>
              <span className="side-menu__label ml-4">Profile</span>
            </Link>
          </li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/changepassword/login"
              className={`side-menu__item ${
                window.location.href.includes("/changepassword/login")
                  ? "active"
                  : ""
              }`}
            >
              <i className="icon-lock"></i>
              <span className="side-menu__label ml-4">
                Change Login Password
              </span>
            </Link>
          </li>
          {/* <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/changepassword/transaction"
              className={`side-menu__item ${
                window.location.href.includes("/changepassword/transaction")
                  ? "active"
                  : ""
              }`}
            >
              <i className="icon-lock"></i>
              <span className="side-menu__label ml-4">
                Change Transaction Password
              </span>
            </Link>
          </li> */}

          <li className="side-item side-item-category mt-4">GENEALOGY</li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/treeview"
              className={`side-menu__item ${
                window.location.href.includes("/treeview") ? "active" : ""
              }`}
            >
              <i className="icon-organization"></i>
              <span className="side-menu__label ml-4">Tree View</span>
            </Link>
          </li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/teamlist"
              className={`side-menu__item ${
                window.location.href.includes("/teamlist") ? "active" : ""
              }`}
            >
              <i className="icon-people"></i>
              <span className="side-menu__label ml-4">Team List</span>
            </Link>
          </li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/directsponsor"
              className={`side-menu__item ${
                window.location.href.includes("/directsponsor") ? "active" : ""
              }`}
            >
              <i className="icon-user-follow"></i>
              <span className="side-menu__label ml-4">Direct Sponsor List</span>
            </Link>
          </li>

          <li className="side-item side-item-category mt-4">Wallet</li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/cwallet"
              className={`side-menu__item ${
                window.location.href.includes("/cwallet") ? "active" : ""
              }`}
            >
              <i className="icon-wallet"></i>
              <span className="side-menu__label ml-4">Payout Wallet</span>
            </Link>
          </li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/purchasehistory"
              className={`side-menu__item ${
                window.location.href.includes("/purchasehistory") ? "active" : ""
              }`}
            >
              <i className="icon-clock"></i>
              <span className="side-menu__label ml-4">Purchase History</span>
            </Link>
          </li>
          
          {/* <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/epin"
              className={`side-menu__item ${
                window.location.href.includes("/epin") ? "active" : ""
              }`}
            >
              <i className="icon-pin"></i>
              <span className="side-menu__label ml-4">E-Pin</span>
            </Link>
          </li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/transfer"
              className={`side-menu__item ${
                window.location.href.includes("/transfer") ? "active" : ""
              }`}
            >
              <i className="icon-cursor"></i>
              <span className="side-menu__label ml-4">Pin Transfer</span>
            </Link>
          </li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/pintransferhistory"
              className={`side-menu__item ${
                window.location.href.includes("/pintransferhistory")
                  ? "active"
                  : ""
              }`}
            >
              <i className="icon-list"></i>
              <span className="side-menu__label ml-4">
                Pin Transfer History
              </span>
            </Link>
          </li> */}

          <li className="side-item side-item-category">INCENTIVE</li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              to="/joiningbonus"
              className={`side-menu__item ${
                window.location.href.includes("/joiningbonus") ? "active" : ""
              }`}
            >
              <i className="icon-badge"></i>
              <span className="side-menu__label ml-4">Affiliate Bonus</span>
            </Link>
          </li>
          <li
            className="slide"
            onClick={() => {
              let elementdiv = document.getElementById("app");
              if (
                window.innerWidth < 700 &&
                elementdiv.classList.contains("sidenav-toggled")
              ) {
                elementdiv.classList.remove("sidenav-toggled");
              }
            }}
          >
            <Link
              className={`side-menu__item ${
                window.location.href.includes("paidsummary") ? "active" : ""
              }`}
              to="/paidsummary"
            >
              <i className="icon-present"></i>
              <span className="side-menu__label ml-4">Paid Summary</span>
            </Link>
          </li>
        </ul>
      </aside>
    );
  }
}
